// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__form___qfnEF {
  width: 100%;
}

.styles__formItem___HwznA {
}

.styles__contentContainer___ooJqt {
  padding-bottom: 20px;
  padding-top: 20px;
}

.styles__section___olZXC {
  width: calc(99.9% * 12/12 - (30px - 30px * 12/12));
  margin-bottom: 20px;
}

.styles__section___olZXC:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__section___olZXC:last-child {
  margin-right: 0;
}

.styles__section___olZXC:nth-child(12n) {
  margin-right: 0;
  float: right;
}

.styles__section___olZXC:nth-child(12n + 1) {
  clear: both;
}

.styles__wrapper___O7R4j {
  display: block;
}

.styles__table___vcQo9 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
  padding: 0 10px 10px;
  width: 100%;
}

.styles__tableRow___wvdei {
  cursor: pointer;
  display: table-row;
  display: flex;
  flex-flow: row wrap;
  padding: 10px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__tableRow___wvdei:hover {
    background: gtGreenLight;
  }

.styles__tableRow___wvdei .styles__column___sV45f {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
    padding-top: 10px;
  }

.styles__tableRow___wvdei .styles__column___sV45f:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }

.styles__tableRow___wvdei .styles__column___sV45f:last-child {
    margin-right: 0;
  }

.styles__tableRow___wvdei .styles__column___sV45f:nth-child(3n) {
    margin-right: 0;
    float: right;
  }

.styles__tableRow___wvdei .styles__column___sV45f:nth-child(3n + 1) {
    clear: both;
  }

.styles__tableRow___wvdei .styles__column___sV45f:first-child {
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
      padding-left: 10px;
    }

.styles__tableRow___wvdei .styles__column___sV45f:last-child {
      padding-top: 0;
    }

.styles__tableHead___lOMLq {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  cursor: auto;
  margin: 0;
}

.styles__tableHead___lOMLq:hover {
    background: none;
  }

.styles__tableHead___lOMLq .styles__column___sV45f {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
    font-size: 12px;
    text-transform: uppercase;
  }

.styles__actionButton___m5_Tn {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  color: white;
  float: right;
  line-height: 19px;
  padding: 10px 20px;
  width: auto;
}

.styles__actionButton___m5_Tn:hover {
    background-color: rgba(55, 110, 161, 0.9);
  }

.styles__actionButton___m5_Tn a {
    color: white;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.styles__filters___f207L {
}

.styles__link___Eccy5 {
  display: inline-flex;
  -webkit-text-decoration: none;
  text-decoration: none;
  width: 100%;
}

.styles__title___yFqf4 {
  margin-top: 40px;
}

.styles__statusActive___sYqh8 {
}

.styles__statusPending___jwbtx {
}

.styles__statusRejected___WyAxf {
}

.styles__searchWrap___diz04 {
}

.styles__search___iH41V {
}

.styles__updateTime___eqGT7 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__recentActivity___Tdr_0 {
}

.styles__recentActivity___Tdr_0 span {
    display: inline-block;
    margin-right: 3px;
  }

.styles__localHeader___SRPis {
}

.styles__localHeaderInner___KlDqW {
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/CoTrustee/components/Tickets/styles.css"],"names":[],"mappings":"AAIA;EACE,WAAW;AACb;;AAEA;AAEA;;AAEA;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EAEE,kDAAkB;EAClB,mBAAmB;AACrB;;AAJA;EAEE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AAEpB;;AAJA;EAEE,eAAkB;AAEpB;;AAJA;EAEE,eAAkB;EAAlB,YAAkB;AAEpB;;AAJA;EAEE,WAAkB;AAEpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8DAA6B;EAC7B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAwB;EAAxB,mBAAwB;EACxB,aAAa;EACb,6BAAqB;EAArB,qBAAqB;AAoBvB;;AAlBE;IACE,wBAAwB;EAC1B;;AAEA;IACE,mDAAc;IACd,8CAAgB;IAChB,iBAAiB;EAUnB;;AAbA;IAEE,WAAgB;IAAhB,kBAAgB;IAAhB,WAAgB;EAWlB;;AAbA;IAEE,eAAgB;EAWlB;;AAbA;IAEE,eAAgB;IAAhB,YAAgB;EAWlB;;AAbA;IAEE,WAAgB;EAWlB;;AARE;MACE,mDAAa;MACb,kBAAkB;IACpB;;AAEA;MACE,cAAc;IAChB;;AAIJ;EACE,mDAAgB;EAEhB,YAAY;EACZ,SAAS;AAWX;;AATE;IACE,gBAAgB;EAClB;;AAEA;IACE,mDAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;AAGF;EACE,wDAAkB;EAClB,YAAY;EAEZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AAUb;;AARE;IACE,yCAAyC;EAC3C;;AAEA;IACE,YAAY;IACZ,6BAAqB;IAArB,qBAAqB;EACvB;;AAGF;AAEA;;AAEA;EACE,oBAAoB;EACpB,6BAAqB;EAArB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;AAOA;;AAJE;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;AAGF;AAEA;;AAEA;AAEA","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayLight, gtBlueDark, gtGray, gtGrayDark, gtRed, gtBlue, textLight, gtGreen from colors;\n\n.form {\n  width: 100%;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\n.section {\n  composes: section from helpers;\n  lost-column: 12/12;\n  margin-bottom: 20px;\n}\n\n.wrapper {\n  display: block;\n}\n\n.table {\n  background-color: gtGrayLight;\n  padding: 0 10px 10px;\n  width: 100%;\n}\n\n.tableRow {\n  cursor: pointer;\n  display: table-row;\n  lost-flex-container: row;\n  padding: 10px;\n  text-decoration: none;\n\n  &:hover {\n    background: gtGreenLight;\n  }\n\n  .column {\n    color: gtGreen;\n    lost-column: 1/3;\n    padding-top: 10px;\n\n    &:first-child {\n      color: gtBlue;\n      padding-left: 10px;\n    }\n\n    &:last-child {\n      padding-top: 0;\n    }\n  }\n}\n\n.tableHead {\n  color: textLight;\n  composes: tableRow;\n  cursor: auto;\n  margin: 0;\n\n  &:hover {\n    background: none;\n  }\n\n  .column {\n    color: textLight;\n    font-size: 12px;\n    text-transform: uppercase;\n  }\n}\n\n.actionButton {\n  background: gtBlue;\n  color: white;\n  composes: button from helpers;\n  float: right;\n  line-height: 19px;\n  padding: 10px 20px;\n  width: auto;\n\n  &:hover {\n    background-color: rgba(55, 110, 161, 0.9);\n  }\n\n  a {\n    color: white;\n    text-decoration: none;\n  }\n}\n\n.filters {\n  composes: clearfix from helpers;\n}\n\n.link {\n  display: inline-flex;\n  text-decoration: none;\n  width: 100%;\n}\n\n.title {\n  composes: h1 from helpers;\n  margin-top: 40px;\n}\n\n.statusActive {\n  composes: statusActive from helpers;\n}\n\n.statusPending {\n  composes: statusPending from helpers;\n}\n\n.statusRejected {\n  composes: statusRejected from helpers;\n}\n\n.searchWrap {\n  composes: searchWrap from helpers;\n}\n\n.search {\n  composes: search from helpers;\n}\n\n.updateTime {\n  color: textLight;\n  font-size: 12px;\n}\n\n.recentActivity {\n  composes: row from helpers;\n\n  span {\n    display: inline-block;\n    margin-right: 3px;\n  }\n}\n\n.localHeader {\n  composes: localHeader from helpers;\n}\n\n.localHeaderInner {\n  composes: localHeaderInner from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"form": `styles__form___qfnEF`,
	"formItem": `styles__formItem___HwznA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"contentContainer": `styles__contentContainer___ooJqt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"section": `styles__section___olZXC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"wrapper": `styles__wrapper___O7R4j`,
	"table": `styles__table___vcQo9`,
	"tableRow": `styles__tableRow___wvdei`,
	"column": `styles__column___sV45f`,
	"tableHead": `styles__tableHead___lOMLq styles__tableRow___wvdei`,
	"actionButton": `styles__actionButton___m5_Tn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"filters": `styles__filters___f207L ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"link": `styles__link___Eccy5`,
	"title": `styles__title___yFqf4 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["h1"]}`,
	"statusActive": `styles__statusActive___sYqh8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"statusPending": `styles__statusPending___jwbtx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"statusRejected": `styles__statusRejected___WyAxf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"searchWrap": `styles__searchWrap___diz04 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["searchWrap"]}`,
	"search": `styles__search___iH41V ${___CSS_LOADER_ICSS_IMPORT_1___.locals["search"]}`,
	"updateTime": `styles__updateTime___eqGT7`,
	"recentActivity": `styles__recentActivity___Tdr_0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"localHeader": `styles__localHeader___SRPis ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeader"]}`,
	"localHeaderInner": `styles__localHeaderInner___KlDqW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeaderInner"]}`
};
export default ___CSS_LOADER_EXPORT___;
